import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;
  max-width: 1024px;
  padding: 0px 20px;
  margin: 0px auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;